/** @prettier */
export const REQUEST_RELATED_EVENTS = 'relatedEvents/REQUEST_RELATED_EVENTS';
export const SET_RELATED_EVENTS = 'relatedEvents/SET_RELATED_EVENTS';

/**
 * @param  {array} results Array of static pages
 * @return {object}
 */

export const requestRelatedEvents = (eventId = '', competition = '') => ({
  type: REQUEST_RELATED_EVENTS,
  payload: {
    eventId,
    competition,
  },
});

export const setRelatedEvents = (competition, events) => ({
  type: SET_RELATED_EVENTS,
  payload: {
    competition,
    events,
  },
});
